module.exports = __webpack_public_path__ + "assets/64441e3c24210bc5d7107db49ee3de2c.png";